export default __webpack_public_path__ + "static/media/operationModes.8dd1db43.svg";